/**
 * Web-to-Case form handling
 * Handles form validation, submission, and result display
 */

(function ($) {

    // Only allow digits, space, dash, parentheses, dot — NO @#$%&*
    var DEFAULT_PATTERN = /^[0-9()\s.-]+$/;
    var DEFAULT_REGEXP = /^(?:\+1\s?)?(?:\(\d{3}\)|\d{3})[\s.-]?\d{3}[\s.-]?\d{4}$/;

    /**
     * Validate email address
     * @param {string} email - The email to validate
     * @returns {boolean} - Whether the email is valid
     */
    function isValidEmail(email) {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    /**
     * Validate phone number
     * @param {*} phoneField - DOM field
     * @returns {boolean} - Whether the phone is valid
     */
    function isValidPhoneField(phoneField) {
        var $phone = $(phoneField);
        var phoneVal = $phone.val().trim();

        if (!phoneVal) { // checking if value exist if not ignoring as phone number is not mandatory
            return true;
        }

        var patternRegExp = $phone.attr('pattern') ? new RegExp($phone.attr('pattern')) : DEFAULT_PATTERN;
        var phoneRegExp = $phone.attr('data-regexp') ? new RegExp($phone.attr('data-regexp')) : DEFAULT_REGEXP;

        var isValid = patternRegExp.test(phoneVal) && phoneRegExp.test(phoneVal);
        return isValid;
    }

    /**
     * Load form properties from embedded JSON
     * @returns {Object} Properties object
     */
    function loadFormProperties() {
        var propertiesScript = $('#webtocase-properties[data-properties]');
        if (propertiesScript.length) {
            try {
                return JSON.parse(propertiesScript.text());
            } catch (e) {
                // Silent fallback to defaults if JSON parsing fails
            }
        }

        // Fallback properties
        return {
            checkboxText: 'I have read and agreed to the Terms Of Use and Privacy Policy.',
            submitButtonText: 'Submit',
            loadingText: 'Sending...',
            successTitle: 'Thanks Beauty!',
            successSubtitle: 'Form Submitted Successfully',
            successDescription: 'Your form has been successfully submitted. Our team will review your information and get back to you as soon as possible.',
            successCaseReference: 'Reference ID: <strong>{0}</strong>',
            errorTitle: 'Oops! Something went wrong',
            errorSubtitle: 'Unable to Submit Form',
            errorDescription: 'We encountered an issue while processing your request. Please try again.',
            errorRetryButton: 'Try Again',
            errorContactButton: 'Contact Support',
            validationRequiredFields: 'Please fill in all required fields',
            validationEmailInvalid: 'Please enter a valid email address',
            validationPhoneInvalid: 'Please enter a valid phone number',
            validationRequiredField: 'This field is required.',
            validationRequiredSelect: 'Please select an option.',
            validationTermsRequired: 'You must accept the Terms of Use and Privacy Policy',
            loadingSending: 'Sending your message...',
            errorSubmissionGeneral: 'An error occurred while submitting your case. Please try again later.',
            errorSubmissionBadRequest: 'Invalid form data. Please check your entries and try again.',
            errorSubmissionServer: 'Server error. Please try again later.',
            errorSubmissionFallback: 'An error occurred while submitting your case.',
            characterCounterFormat: '{0} / {1}'
        };
    }

    /**
     * WebToCase form handler
     * @param {HTMLElement} form - The form element
     * @constructor
     */
    function WebToCaseForm(form) {
        this.form = $(form);
        this.properties = loadFormProperties();
        this.submitButton = this.form.find('#webtocase-submit, #webtocase-submit-recaptcha');
        this.isSubmitting = false;
        this.characterCounter = this.form.find('#webtocase-description-counter');
        this.textareaField = this.form.find('#webtocase-description');
        this.termsCheckbox = this.form.find('#webtocase-terms');

        this.init();
    }

    /**
     * Initialize the form handler
     */
    WebToCaseForm.prototype.init = function () {
        this.bindEvents();
        this.setupValidation();
        this.setupCharacterCounter();
        this.setupFloatingLabels();
        this.setupFormStateManagement();
    };

    /**
     * Bind form events
     */
    WebToCaseForm.prototype.bindEvents = function () {
        var self = this;

        // Handle form submission
        this.form.on('submit', function (e) {
            e.preventDefault();
            self.handleSubmit();
        });

        // Real-time validation
        this.form.find('input, textarea, select').on('blur change', function () {
            self.validateField($(this));
        });

        // Clear validation on input
        this.form.find('input, textarea').on('input', function () {
            var field = $(this);
            if (field.hasClass('is-invalid')) {
                field.removeClass('is-invalid');
            }
        });

        // Clear validation on select change
        this.form.find('select').on('change', function () {
            var field = $(this);
            if (field.hasClass('is-invalid')) {
                field.removeClass('is-invalid');
            }
        });
    };

    /**
     * Setup form validation
     */
    WebToCaseForm.prototype.setupValidation = function () {
        var formInstance = this;

        // Add custom validation patterns
        var emailField = this.form.find('#webtocase-email');
        var phoneField = this.form.find('#webtocase-phone');

        // Email validation
        if (emailField && emailField.length) {
            emailField.on('blur', function () {
                var email = $(this).val().trim();
                var fieldId = $(this).attr('id');
                var errorContainer = $('#' + fieldId + '-error');

                if (email && !isValidEmail(email)) {
                    $(this).addClass('is-invalid has-error');
                    if (errorContainer && errorContainer.length) {
                        errorContainer.text(formInstance.properties.validationEmailInvalid).addClass('show');
                    }
                } else {
                    $(this).removeClass('is-invalid has-error');
                    if (errorContainer && errorContainer.length) {
                        errorContainer.text('').removeClass('show');
                    }
                }
            });
        }

        // Phone validation (optional but if provided, should be valid)
        if (phoneField && phoneField.length) {
            phoneField.on('blur', function () {
                var phone = $(this).val().trim();
                var fieldId = $(this).attr('id');
                var errorContainer = $('#' + fieldId + '-error');

                if (phone && !isValidPhoneField(this)) {
                    $(this).addClass('is-invalid has-error');
                    if (errorContainer && errorContainer.length) {
                        errorContainer.text(formInstance.properties.validationPhoneInvalid).addClass('show');
                    }
                } else {
                    $(this).removeClass('is-invalid has-error');
                    if (errorContainer && errorContainer.length) {
                        errorContainer.text('').removeClass('show');
                    }
                }
            });
            phoneField.on('input', function () {
                var $phone = $(this);
                var phoneVal = $phone.val();
                var restrictedChars = $phone.attr('data-restricted-chars');
                if (phoneVal && restrictedChars) {
                    var prefix = $phone.attr('data-prefix');
                    // restricted chars should also contain prefix, allows to ensure prefix is set only once
                    var stripRegExp = new RegExp(restrictedChars, 'g');
                    phoneVal = phoneVal.replace(stripRegExp, '');
                    // reapply prefix if defined
                    if (prefix && !phoneVal.startsWith(prefix)) {
                        phoneVal = prefix + phoneVal;
                    }
                    $phone.val(phoneVal);
                }
            });
        }
    };

    /**
     * Set up character counter for textarea
     */
    WebToCaseForm.prototype.setupCharacterCounter = function () {
        var self = this;
        if (this.textareaField && this.textareaField.length && this.characterCounter && this.characterCounter.length) {
            // Update counter on input
            this.textareaField.on('input', function () {
                var currentLength = $(this).val().length;
                var maxLength = parseInt($(this).attr('maxlength'), 10) || 1000;

                if (self.characterCounter && self.characterCounter.length) {
                    var counterText = self.properties.characterCounterFormat.replace('{0}', currentLength).replace('{1}', maxLength);
                    self.characterCounter.text(counterText);

                    // Add warning class when nearing limit
                    if (currentLength > maxLength * 0.9) {
                        self.characterCounter.addClass('char-counter-warning');
                    } else {
                        self.characterCounter.removeClass('char-counter-warning');
                    }
                }
            });

            // Initialize counter
            this.textareaField.trigger('input');
        }
    };

    /**
     * Set up floating labels (Figma design)
     */
    WebToCaseForm.prototype.setupFloatingLabels = function () {
        var self = this;
        var formFields = this.form.find('.webtocase-input, .webtocase-textarea');

        formFields.each(function () {
            var field = $(this);
            var label = field.siblings('.webtocase-label');

            if (label && label.length) {
                // Check initial state on load
                self.updateFloatingLabel(field, label);

                // Handle focus event
                field.on('focus', function () {
                    label.addClass('floating focused');
                    field.addClass('has-focus');
                });

                // Handle blur event
                field.on('blur', function () {
                    label.removeClass('focused');
                    field.removeClass('has-focus');
                    self.updateFloatingLabel(field, label);
                });

                // Handle input event (typing)
                field.on('input', function () {
                    self.updateFloatingLabel(field, label);
                });

                // Handle change event (for select dropdowns and programmatic changes)
                field.on('change', function () {
                    self.updateFloatingLabel(field, label);
                    // Update form state when dropdown selection changes
                    self.updateFormState();
                });
            }
        });
    };

    /**
     * Update floating label state based on field value
     * @param {jQuery} field - The input field
     * @param {jQuery} label - The associated label
     */
    WebToCaseForm.prototype.updateFloatingLabel = function (field, label) {
        if (!field || !field.length || !label || !label.length) {
            return;
        }

        var fieldValue = field.val();
        var hasValue = fieldValue && fieldValue.trim().length > 0;
        var isFocused = field.is(':focus');

        // For select dropdowns, check if a non-empty option is selected
        if (field.is('select')) {
            hasValue = fieldValue && fieldValue !== '';
        }

        // Add/remove has-value class on field
        if (hasValue) {
            field.addClass('has-value');
        } else {
            field.removeClass('has-value');
        }

        // Add/remove floating class on label
        // For select dropdowns, always keep the label floating since the placeholder is generic
        if (field.is('select')) {
            label.addClass('floating');
        } else if (hasValue || isFocused) {
            // For other input types, float on focus or when there's a value
            label.addClass('floating');
        } else {
            label.removeClass('floating');
        }
    };

    /**
     * Set up form state management (enable/disable submit button)
     */
    WebToCaseForm.prototype.setupFormStateManagement = function () {
        var self = this;

        // Add event listeners to all form fields
        var formFields = this.form.find('input[required], textarea[required]');
        var termsCheckbox = this.termsCheckbox;

        // Update form state on field changes
        formFields.on('input blur change', function () {
            self.updateFormState();
        });

        // Update form state on terms checkbox change
        if (termsCheckbox && termsCheckbox.length) {
            termsCheckbox.on('change', function () {
                self.updateFormState();
                self.validateTermsCheckbox();
            });
        }

        // Initial form state check
        this.updateFormState();
    };

    /**
     * Update form state (enable/disable submit button based on validation)
     */
    WebToCaseForm.prototype.updateFormState = function () {
        if (!this.submitButton || !this.submitButton.length) {
            return;
        }

        var isFormValid = this.isFormValid();

        if (isFormValid) {
            this.submitButton.prop('disabled', false);
        } else {
            this.submitButton.prop('disabled', true);
        }
    };

    /**
     * Check if form is valid (all required fields filled and terms accepted)
     * @returns {boolean} - Whether the form is valid
     */
    WebToCaseForm.prototype.isFormValid = function () {
        var requiredFields = this.form.find('input[required], textarea[required], select[required]');
        var allFieldsValid = true;
        var termsAccepted = true;

        // Check required fields
        requiredFields.each(function () {
            var field = $(this);
            var value = field.val();

            // For select fields, check if a non-empty option is selected
            if (field.is('select')) {
                if (!value || value === '') {
                    allFieldsValid = false;
                    return false; // Break out of each loop
                }
            } else if (!value || value.trim().length === 0) {
                allFieldsValid = false;
                return false; // Break out of each loop
            }

            // Additional email validation
            if (field.attr('type') === 'email') {
                var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value)) {
                    allFieldsValid = false;
                    return false;
                }
            }

            return true; // Field is valid
        });

        // check valid phone if provided
        var phoneField = this.form.find('#webtocase-phone');
        var phoneNo = $.trim((phoneField.val() || '').toString());
        var isPhoneValid = isValidPhoneField(phoneField);

        if (phoneNo !== '') {
            if (!isPhoneValid) {
                allFieldsValid = false;
            }
        }

        // Check terms checkbox
        if (this.termsCheckbox && this.termsCheckbox.length) {
            termsAccepted = this.termsCheckbox.is(':checked');
        }

        return allFieldsValid && termsAccepted;
    };

    /**
     * Validate terms checkbox
     * @returns {boolean} - Whether the terms checkbox is valid
     */
    WebToCaseForm.prototype.validateTermsCheckbox = function () {
        if (!this.termsCheckbox || !this.termsCheckbox.length) {
            return true;
        }

        var errorContainer = $('#webtocase-terms-error');
        var isChecked = this.termsCheckbox.is(':checked');

        if (!isChecked && this.termsCheckbox.prop('required')) {
            return false;
        }

        if (errorContainer && errorContainer.length) {
            errorContainer.text('');
            errorContainer.removeClass('show');
        }
        return true;
    };

    /**
     * Validate individual field
     * @param {jQuery} field - The field to validate
     * @returns {boolean} - Whether the field is valid
     */
    WebToCaseForm.prototype.validateField = function (field) {
        if (!field || !field.length) {
            return true; // Skip validation if field doesn't exist
        }

        var isValid = true;
        var value = field.val().trim();
        var isRequired = field.prop('required');
        var fieldId = field.attr('id');
        var errorContainer = fieldId ? $('#' + fieldId + '-error') : $();

        // Clear previous validation state
        if (field && field.length) {
            field.removeClass('is-invalid has-error');
        }
        if (errorContainer && errorContainer.length) {
            errorContainer.text('').removeClass('show');
        }

        // Required field validation
        if (isRequired && !value) {
            if (field && field.length) {
                field.addClass('is-invalid has-error');
            }
            if (errorContainer && errorContainer.length) {
                var errorMessage = this.properties.validationRequiredField;
                if (field.is('select')) {
                    errorMessage = this.properties.validationRequiredSelect;
                }
                errorContainer.text(errorMessage).addClass('show');
            }
            isValid = false;
        } else if (value) {
            // Type-specific validation
            var fieldType = field.attr('type');
            var fieldName = field.attr('name');

            if (fieldType === 'email' && !isValidEmail(value)) {
                if (field && field.length) {
                    field.addClass('is-invalid has-error');
                }
                if (errorContainer && errorContainer.length) {
                    errorContainer.text(this.properties.validationEmailInvalid).addClass('show');
                }
                isValid = false;
            } else if (fieldName === 'phone' && !isValidPhoneField(field)) {
                if (field && field.length) {
                    field.addClass('is-invalid has-error');
                }
                if (errorContainer && errorContainer.length) {
                    errorContainer.text(this.properties.validationPhoneInvalid).addClass('show');
                }
                isValid = false;
            } else if (field && field.length) {
                field.removeClass('is-invalid has-error');
            }
        }

        return isValid;
    };

    /**
     * Validate entire form
     * @returns {boolean} - Whether the form is valid
     */
    WebToCaseForm.prototype.validateForm = function () {
        var self = this;
        var isValid = true;

        // Validate all required fields
        this.form.find('input[required], textarea[required], select[required]').each(function () {
            if (!self.validateField($(this))) {
                isValid = false;
            }
        });

        // Validate terms checkbox
        if (!this.validateTermsCheckbox()) {
            isValid = false;
        }

        return isValid;
    };

    /**
     * Handle form submission
     */
    WebToCaseForm.prototype.handleSubmit = function () {
        if (this.isSubmitting) {
            return;
        }

        // Validate form
        if (!this.validateForm()) {
            this.showResult('error', this.properties.validationRequiredFields);
            return;
        }

        this.setSubmitting(true);
        this.hideResult();

        var self = this;
        var formData = this.form.serialize();
        var submitUrl = this.form.data('action');

        $.ajax({
            url: submitUrl,
            type: 'POST',
            data: formData,
            dataType: 'json',
            timeout: 30000,
            success: function (response) {
                self.handleSubmitSuccess(response);
            },
            error: function (xhr, status, error) {
                self.handleSubmitError(xhr, status, error);
            },
            complete: function () {
                self.setSubmitting(false);
            }
        });
    };

    /**
     * Handle successful submission
     * @param {Object} response - The response from the server
     */
    WebToCaseForm.prototype.handleSubmitSuccess = function (response) {
        var $webToCaseHeader = $('.webtocase-header');

        if (response.success) {
            this.showResult('success', response.message, response.caseId);
            this.resetForm();
        } else {
            this.showResult('error', response.error || this.properties.errorSubmissionFallback);
        }

        $webToCaseHeader.addClass('d-none');
    };

    /**
     * Handle submission error
     * @param {Object} xhr - The XMLHttpRequest object
     * @param {string} status - The status of the request
     */
    WebToCaseForm.prototype.handleSubmitError = function (xhr, status) {
        var message = this.properties.errorSubmissionGeneral;

        if (status === 'timeout') {
            message = this.properties.errorSubmissionGeneral; // Use general for timeout
        } else if (xhr.status === 400) {
            message = this.properties.errorSubmissionBadRequest;
        } else if (xhr.status >= 500) {
            message = this.properties.errorSubmissionServer;
        }

        this.showResult('error', message);
    };

    /**
     * Set submitting state
     * @param {boolean} isSubmitting - Whether the form is submitting
     */
    WebToCaseForm.prototype.setSubmitting = function (isSubmitting) {
        this.isSubmitting = isSubmitting;

        if (this.submitBtn && this.submitBtn.length) {
            var contentElement = this.submitBtn.find('.submit-button-content');
            var loadingElement = this.submitBtn.find('.submit-button-loading');

            if (isSubmitting) {
                this.submitBtn.prop('disabled', true);

                if (contentElement && contentElement.length) {
                    contentElement.addClass('d-none');
                }
                if (loadingElement && loadingElement.length) {
                    loadingElement.removeClass('d-none');
                }

                this.submitBtn.attr('aria-describedby', 'webtocase-submit-status');
                $('#webtocase-submit-status').text(this.properties.loadingSending);
            } else {
                this.submitBtn.prop('disabled', false);

                if (contentElement && contentElement.length) {
                    contentElement.removeClass('d-none');
                }
                if (loadingElement && loadingElement.length) {
                    loadingElement.addClass('d-none');
                }

                $('#webtocase-submit-status').text('');
            }
        }
    };

    /**
     * Show result message and replace form content
     * @param {string} type - The type of result (success, error)
     * @param {string} message - The message to display
     * @param {string} caseId - Optional case ID for success messages
     */
    WebToCaseForm.prototype.showResult = function (type, message, caseId) {
        var isSuccess = type === 'success';

        // Create modern success/error state replacement
        var resultHtml = '<div class="webtocase-success-state" role="status" aria-live="polite">';

        if (isSuccess) {
            // Success state using properties
            resultHtml += '<div class="figma-success-content">' +
                '  <h1 class="figma-success-title">' + this.properties.successTitle + '</h1>' +
                '  <div class="figma-success-details">' +
                '    <h2 class="figma-success-subtitle">' + this.properties.successSubtitle + '</h2>' +
                '    <p class="figma-success-description">' + this.properties.successDescription + '</p>' +
                '  </div>';

            // Add case ID if provided (optional, styled to match)
            if (caseId) {
                var caseReferenceText = this.properties.successCaseReference.replace('{0}', caseId);
                resultHtml += '<div class="figma-case-reference">' +
                    '  <p class="case-reference-text">' + caseReferenceText + '</p>' +
                    '</div>';
            }

            resultHtml += '</div>';
        } else {
            // Error state with modern design elements
            resultHtml += '<div class="error-content">' +
                '  <div class="error-icon-wrapper">' +
                '    <div class="error-icon">' +
                '      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '        <circle cx="24" cy="24" r="24" fill="#B21026"/>' +
                '        <path d="M16 16L32 32M16 32L32 16" stroke="white" stroke-width="2" stroke-linecap="round"/>' +
                '      </svg>' +
                '    </div>' +
                '  </div>' +
                '  <div class="error-message">' +
                '    <h3 class="error-title">' + this.properties.errorTitle + '</h3>' +
                '    <p class="error-description">' + (message || this.properties.errorDescription) + '</p>' +
                '  </div>' +
                '  <div class="error-actions">' +
                '    <button type="button" class="webtocase-primary-action webtocase-retry-btn">' +
                '      <span class="action-icon">' +
                '        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '          <path d="M1 4V10A6 6 0 0 0 7 16L8 14A4 4 0 0 1 3 10V4L1 4Z" fill="currentColor"/>' +
                '          <path d="M15 12V6A6 6 0 0 0 9 0L8 2A4 4 0 0 1 13 6V12L15 12Z" fill="currentColor"/>' +
                '        </svg>' +
                '      </span>' +
                '      ' + this.properties.errorRetryButton +
                '    </button>' +
                '    <div class="additional-help">' +
                '      <p class="help-text">' + this.properties.errorContactText + ' <a href="tel:1-800-MARYKAY" class="help-link">1-800-MARYKAY</a></p>' +
                '    </div>' +
                '  </div>' +
                '</div>';
        }

        resultHtml += '</div>';

        // Replace the entire form with the result state
        this.form.replaceWith(resultHtml);

        // Smooth scroll to the result (Figma design - no action buttons needed)
        var resultElement = $('.webtocase-success-state');
        if (resultElement && resultElement.length && resultElement.get(0)) {
            resultElement.get(0).scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    };

    /**
     * Hide result message
     */
    WebToCaseForm.prototype.hideResult = function () {
        // Since we now replace the form completely with success/error states,
        // this function is no longer needed but kept for compatibility
        var resultContainer = $('.webtocase-result, .webtocase-success-state');
        if (resultContainer && resultContainer.length) {
            resultContainer.addClass('d-none');
        }
    };

    /**
     * Reset form to initial state
     */
    WebToCaseForm.prototype.resetForm = function () {
        this.form[0].reset();
        this.form.find('.is-invalid').removeClass('is-invalid');
    };

    /**
     * Initialize WebToCase forms when DOM is ready or when dynamically loaded
     */
    function initializeWebToCaseForms() {
        $('#webtocase-form').each(function () {
            // Prevent double initialization
            if (!$(this).data('webtocase-initialized')) {
                $(this).data('webtocase-initialized', true);
                var formHandler = new WebToCaseForm(this);
                $(this).data('webtocase-handler', formHandler);

                // Expose form instance globally for reCAPTCHA callback
                window.webToCaseFormInstance = formHandler;
            }
        });
    }

    // Initialize on DOM ready
    $(document).ready(function () {
        initializeWebToCaseForms();
    });

    /**
     * Google reCAPTCHA callback for WebToCase form
     * This function is called by Google reCAPTCHA when the user completes the challenge
     * @param {string} token - The reCAPTCHA token from Google
     */
    window.onSubmitCaptchaWebToCase = function (token) {
        var $gCaptchaInput = $('#grecaptchatoken-webtocase');
        var $submitButton = $('#webtocase-submit');

        if ($gCaptchaInput.length && $submitButton.length) {
            $gCaptchaInput.val(token);
            $submitButton.click();
        }
    };

    // Also initialize when new content is added (for remote includes)
    $(document).on('DOMNodeInserted', function (e) {
        if ($(e.target).find('#webtocase-form').length || $(e.target).is('#webtocase-form')) {
            initializeWebToCaseForms();
        }
    });

    // Fallback: Use event delegation for form submission
    $(document).on('submit', '#webtocase-form', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // If form handler isn't initialized yet, initialize it now
        if (!$(this).data('webtocase-initialized')) {
            $(this).data('webtocase-initialized', true);
            var formHandler = new WebToCaseForm(this);
            $(this).data('webtocase-handler', formHandler);
            formHandler.handleSubmit();
        } else {
            // Use existing handler
            var existingHandler = $(this).data('webtocase-handler');
            if (existingHandler && existingHandler.handleSubmit) {
                existingHandler.handleSubmit();
            }
        }
        return false;
    });

    $(document).on('click', '.webtocase-success-state .webtocase-retry-btn', function (e) {
        e.preventDefault();
        window.location.reload();
    });

})(jQuery);
